import axiosClient from './axiosClient';
import { Notification, NotificationPreferences } from '@/types';

interface NotificationQueryParams {
  is_read?: boolean;
  skip?: number;
  limit?: number;
}

export const notificationAPI = {
  async getNotifications(params?: NotificationQueryParams): Promise<Notification[]> {
    const response = await axiosClient.get<Notification[]>('/notifications', { params });
    return response.data;
  },

  async markAsRead(notificationId: string): Promise<void> {
    await axiosClient.put(`/notifications/${notificationId}/read`);
  },

  async deleteNotification(notificationId: string): Promise<void> {
    await axiosClient.delete(`/notifications/${notificationId}`);
  },

  async getPreferences(): Promise<NotificationPreferences> {
    const response = await axiosClient.get<NotificationPreferences>('/notification-preferences/me');
    return response.data;
  },

  async updatePreferences(
    payload: Partial<NotificationPreferences>
  ): Promise<NotificationPreferences> {
    const response = await axiosClient.put<NotificationPreferences>('/notification-preferences/me', payload);
    return response.data;
  },
};

